import { EventStore } from "@bryntum/schedulerpro";
import { Event } from "../models/Event";
import { SwivuStoreArchiveMixin } from "./mixins/SwivuStoreArchiveMixin";
import { SwivuConnectedStoreMixin } from "./mixins/SwivuConnectedStoreMixin";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";

export class SwivuEventStore extends SwivuConnectedStoreMixin(SwivuStoreArchiveMixin(EventStore)) {
  static get $name() {
    return "SwivuEventStore";
  }

  static get configurable() {
    return {
      storeId: STORE_KEYS.eventStore,
      modelClass: Event,
    };
  }
}
